'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _FormField = require('./FormField');

var _FormField2 = _interopRequireDefault(_FormField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputField = function (_Component) {
  _inherits(InputField, _Component);

  function InputField() {
    _classCallCheck(this, InputField);

    var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(InputField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          accept = _props.accept,
          autofocus = _props.autofocus,
          disabled = _props.disabled,
          name = _props.name,
          placeholder = _props.placeholder,
          readonly = _props.readonly,
          size = _props.size,
          type = _props.type,
          value = _props.value,
          defaultValue = _props.defaultValue,
          labelClass = _props.labelClass,
          descriptionClass = _props.descriptionClass,
          controlClass = _props.controlClass,
          errorClass = _props.errorClass,
          hintClass = _props.hintClass,
          hint = _props.hint,
          label = _props.label,
          description = _props.description,
          max = _props.max,
          maxlength = _props.maxlength,
          min = _props.min,
          minlength = _props.minlength,
          pattern = _props.pattern,
          required = _props.required,
          step = _props.step,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus;

      var error = this.props.error || this.state.error;
      var id = this.props.id || _uuid2.default.v1();

      var fieldAttrs = {
        error: error,
        hint: hint,
        id: id,
        label: label,
        description: description,
        labelClass: labelClass,
        descriptionClass: descriptionClass,
        errorClass: errorClass,
        hintClass: hintClass
      };

      var inputAttrs = {
        accept: accept,
        autoFocus: autofocus,
        disabled: disabled,
        id: id,
        name: name,
        placeholder: placeholder,
        readOnly: readonly,
        size: size,
        type: type,
        defaultValue: defaultValue,
        value: value,
        max: max,
        maxLength: maxlength,
        min: min,
        minLength: minlength,
        pattern: pattern,
        required: required,
        step: step,
        onBlur: onBlur,
        onFocus: onFocus
      };

      var className = (0, _classnames3.default)(_defineProperty({
        InputField: true
      }, this.props.className, !!this.props.className));

      return _react2.default.createElement(
        _FormField2.default,
        _extends({ className: className }, fieldAttrs),
        _react2.default.createElement('input', _extends({}, inputAttrs, {
          ref: function ref(el) {
            return _this2.input = el;
          },
          className: controlClass,
          onChange: this.handleChange.bind(this),
          onInput: this.handleInput.bind(this),
          onInvalid: this.handleInvalid.bind(this) }))
      );
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      if (this.props.onChange) {
        this.props.onChange(e);
      }

      var validate = this.props.validate || this.state.validate;
      if (validate) {
        this.checkError(e);
      }
    }
  }, {
    key: 'handleInput',
    value: function handleInput(e) {
      if (this.props.onInput) {
        this.props.onInput(e);
      }

      var validate = this.props.validate || this.state.validate;
      if (validate) {
        this.checkError(e);
      }
    }
  }, {
    key: 'handleInvalid',
    value: function handleInvalid(e) {
      this.setState({ validate: true });
      this.checkError(e);
    }
  }, {
    key: 'checkError',
    value: function checkError(e) {
      var input = this.input;
      var validity = input.validity;

      this.setState({ error: this.props.validationMessage(validity, input) });
    }
  }]);

  return InputField;
}(_react.Component);

InputField.defaultProps = {
  type: 'text',
  validationMessage: function validationMessage(validity, el) {
    return el.validationMessage;
  }
};
exports.default = InputField;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-forms/lib/InputField.js
// module id = 1108
// module chunks = 0